"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerInput = DatePickerInput;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _AdapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _xDatePickers = require("@mui/x-date-pickers");
var _locale = require("date-fns/locale");
var _DateFormat = require("./DateFormat.types");
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function DatePickerInput(config) {
  var mode = config.mode,
    name = config.name,
    _config$value = config.value,
    value = _config$value === void 0 ? '' : _config$value,
    _config$format = config.format,
    format = _config$format === void 0 ? mode === 'date' ? _DateFormat.DEFAULT_DATE_FORMAT : _DateFormat.DEFAULT_DATETIME_FORMAT : _config$format,
    _config$locale = config.locale,
    locale = _config$locale === void 0 ? _locale.es : _config$locale,
    required = config.required,
    onValueChanged = config.onValueChanged;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    date = _useState4[0],
    setDate = _useState4[1];
  var _useState5 = (0, _react.useState)({
      valid: true,
      blurer: setBlured
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    validation = _useState6[0],
    setValidation = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var validate = (0, _react.useCallback)(function (targetValue) {
    var date = null;
    if (targetValue) {
      date = (0, _DateFormat.parseDate)(targetValue, format);
    }
    var valid = !required || _validators.TEXT_REQUIRED_VALIDATOR.isValid(targetValue);
    return [{
      valid: valid,
      blurer: setBlured
    }, date];
  }, [required, format]);
  (0, _react.useEffect)(function () {
    var _validate = validate(value),
      _validate2 = _slicedToArray(_validate, 2),
      validation = _validate2[0],
      date = _validate2[1];
    setDate(date);
    setValidation(validation);
    setError(validation.valid ? '' : _validators.TEXT_REQUIRED_VALIDATOR.getMessage());
  }, [validate, value]);
  var onChange = function onChange(value) {
    setDate(value);
    var formattedValue = '';
    if (value) {
      formattedValue = (0, _DateFormat.formatDate)({
        date: value,
        pattern: format,
        locale: locale
      });
    }
    var _validate3 = validate(formattedValue),
      _validate4 = _slicedToArray(_validate3, 1),
      validation = _validate4[0];
    onValueChanged(name, formattedValue, validation);
  };
  var inputBlured = function inputBlured(_event) {
    if (!blured) {
      setBlured(true);
    }
  };
  var commonProperties = function commonProperties() {
    return {
      label: config.label,
      value: date,
      onChange: onChange,
      disableFuture: config.disableFuture,
      disablePast: config.disablePast,
      disabled: config.disabled,
      minDate: config.minDate,
      maxDate: config.maxDate,
      inputFormat: format,
      disableMaskedInput: true,
      renderInput: function renderInput(params) {
        var _a, _b;
        return /*#__PURE__*/_react["default"].createElement(_material.TextField, Object.assign({}, params, {
          size: (_a = config.size) !== null && _a !== void 0 ? _a : 'small',
          variant: (_b = config.variant) !== null && _b !== void 0 ? _b : 'outlined',
          margin: "dense",
          error: blured && !validation.valid,
          helperText: blured ? error : '',
          required: required,
          onBlur: inputBlured,
          fullWidth: true
        }));
      }
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDateFns.AdapterDateFns,
    adapterLocale: locale,
    dateFormats: {
      normalDate: format,
      keyboardDate: format
    }
  }, mode === 'date' && /*#__PURE__*/_react["default"].createElement(_xDatePickers.DatePicker, Object.assign({}, commonProperties())), mode === 'datetime' && /*#__PURE__*/_react["default"].createElement(_xDatePickers.DateTimePicker, Object.assign({}, commonProperties())));
}